import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { useGameEnvironment } from '../../../loaders/useGameEnvironment';
import { GameEnvironmentForm } from './gameEnvironmentForm';
import { Card } from 'react-bootstrap';

export interface GameEnvironmentCardProps {
    updateCallbackTrigger: (clearActiveGameEnvironment?: boolean) => void;
}

export const NewGameEnvironmentCard: FC<GameEnvironmentCardProps> = observer((props: GameEnvironmentCardProps) => {

    const gameEnvironmentResult = useGameEnvironment();

    return (
        !gameEnvironmentResult.isLoaded
            ? <CustomSpinner spinnerText="Loading game environment..." />
            : gameEnvironmentResult.gameEnvironment &&
            <Card key={gameEnvironmentResult.gameEnvironment.id} className={'m3Card'}>
                <Card.Body className={'cardBody'}>
                    <GameEnvironmentForm gameEnvironment={gameEnvironmentResult.gameEnvironment}
                                         updateCallbackTrigger={props.updateCallbackTrigger} />
                </Card.Body>
            </Card>
    );
});
